import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const VolumeVault = () => {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [vaultsSolved, setVaultsSolved] = useState(0);

  const generateQuestion = () => {
    const types = [
      { shape: "cube", side: 4, question: "volume", answer: 64, formula: "side³" },
      { shape: "cube", side: 5, question: "volume", answer: 125, formula: "side³" },
      { shape: "cuboid", length: 6, width: 4, height: 3, question: "volume", answer: 72, formula: "l×w×h" },
      { shape: "cuboid", length: 8, width: 5, height: 2, question: "volume", answer: 80, formula: "l×w×h" },
      { shape: "cube", side: 3, question: "volume", answer: 27, formula: "side³" },
      { shape: "cube", side: 6, question: "volume", answer: 216, formula: "side³" },
      { shape: "cuboid", length: 10, width: 3, height: 4, question: "volume", answer: 120, formula: "l×w×h" },
      { shape: "cuboid", length: 7, width: 6, height: 2, question: "volume", answer: 84, formula: "l×w×h" },
      { shape: "cube", side: 2, question: "volume", answer: 8, formula: "side³" },
      { shape: "cuboid", length: 5, width: 5, height: 5, question: "volume", answer: 125, formula: "l×w×h" },
      { shape: "cuboid", length: 9, width: 4, height: 3, question: "volume", answer: 108, formula: "l×w×h" },
    ];
    const q = types[Math.floor(Math.random() * types.length)];
    setQuestion(q);
    setUserAnswer('');
    setFeedback('');
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!question) return;

    const answer = parseInt(userAnswer);
    if (answer === question.answer) {
      setScore(score + 20);
      setVaultsSolved(vaultsSolved + 1);
      setFeedback('✅ Vault Unlocked!');
      setTimeout(generateQuestion, 1500);
    } else {
      setFeedback(`❌ Wrong! Answer: ${question.answer} cu cm`);
      setTimeout(generateQuestion, 2500);
    }
  };

  const getQuestionText = () => {
    if (!question) return '';
    if (question.shape === 'cube') {
      return `Cube with side ${question.side} cm. Find volume:`;
    } else {
      return `Cuboid: ${question.length}cm × ${question.width}cm × ${question.height}cm. Find volume:`;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-500 via-red-500 to-pink-600 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 mb-6 text-white">
          <div className="flex justify-between items-center">
            <button onClick={() => navigate('/games')} className="hover:text-yellow-300">← Back</button>
            <h1 className="text-3xl font-bold">🔐 Volume Vault</h1>
            <div className="text-2xl font-bold">{score} pts</div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">📦</div>
            <h2 className="text-2xl font-bold text-gray-800">Calculate Volume!</h2>
            <p className="text-gray-600">Vaults Unlocked: {vaultsSolved}</p>
          </div>

          {question && (
            <div className="text-center">
              <div className="text-xl font-bold text-orange-700 mb-6">{getQuestionText()}</div>
              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <input
                  type="number"
                  value={userAnswer}
                  onChange={(e) => setUserAnswer(e.target.value)}
                  className="w-full text-4xl text-center border-4 border-orange-300 rounded-lg p-4 mb-4 focus:border-orange-500 focus:outline-none"
                  placeholder="? cu cm"
                  autoFocus
                />
                <button type="submit" className="w-full bg-orange-600 text-white text-xl font-bold py-4 rounded-lg hover:bg-orange-700">
                  Unlock Vault!
                </button>
              </form>
              {feedback && (
                <div className={`mt-4 text-xl font-bold ${feedback.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
                  {feedback}
                </div>
              )}
            </div>
          )}

          <div className="mt-8 p-4 bg-orange-50 rounded-lg text-sm">
            <p><strong>💡 Volume Formulas:</strong></p>
            <p>• Cube: side × side × side (side³)</p>
            <p>• Cuboid: length × width × height</p>
            <p>• Volume is measured in cubic units (cu cm, cu m)</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VolumeVault;